// Libraries

// Supermove
import {UrlFiltersType, UrlFiltersUpdateInput, useRef} from '@supermove/hooks';

// App
import {ProjectPageUrlFiltersType} from 'modules/Project/V2/types/ProjectPageUrlFilters';

// Creates a wrapper around url filters that controls if a scroll should happen
// By default when a block is updated, the user clicked something to make it happen and we should scroll.
// However, when a block loads the section can change automatically and we should not scroll.
const useAutoscrollWrappers = ({
  urlFilters,
  startsOnFirstBlock = false,
}: {
  urlFilters: UrlFiltersType<ProjectPageUrlFiltersType>;
  startsOnFirstBlock?: boolean;
}) => {
  const shouldAutoscroll = useRef(!startsOnFirstBlock);

  const wrappedUrlFilters = {
    ...urlFilters,
    handleUpdate: (
      updatedFilters: UrlFiltersUpdateInput<ProjectPageUrlFiltersType>,
      isPushRoute?: boolean,
      options?: {avoidAutoscroll?: boolean},
    ) => {
      if (
        updatedFilters.block &&
        updatedFilters.block !== urlFilters.get('block') &&
        !options?.avoidAutoscroll
      ) {
        shouldAutoscroll.current = true;
      }
      return urlFilters.handleUpdate(updatedFilters, isPushRoute);
    },
    handleReset: (updatedFilters: Partial<ProjectPageUrlFiltersType>, isPushRoute?: boolean) => {
      if (updatedFilters.block && updatedFilters.block !== urlFilters.get('block')) {
        shouldAutoscroll.current = true;
      }
      return urlFilters.handleReset(updatedFilters, isPushRoute);
    },
  };
  return {
    wrappedUrlFilters,
    shouldAutoscroll,
  };
};

export default useAutoscrollWrappers;
